import { React, useEffect, useState, useContext } from "react";
import LoadingOverlay from "react-loading-overlay";
import ReactBSAlert from "react-bootstrap-sweetalert";
import {
  timezones,
  daylightMinutes,
  daylightWeekNumbers,
  offsetMinutes,
  daylightMode,
  weekdays,
  months,
  hours,
} from "data/timezones.js";
import {
  Card,
  CardBody,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  FormGroup,
  Input,
  Form,
  Button,
} from "reactstrap";
import { NavLink as DomNavLink, useHistory } from "react-router-dom";
import Switch from "react-bootstrap-switch";
import Select from "react-select";
import SelectComponent from "components/Utils/select.js";
import { ToastContainer, toast } from "react-toastify";
import { MainContext } from "context/MainContext.js";
LoadingOverlay.propTypes = undefined;

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";

function SettingEdit() {
  const [horizontalTabs, setHorizontalTabs] = useState("general");
  const [gamDaytimeTabs, setGamDaytimeTabs] = useState("gamTimezone");
  const [privilegeTabs, setPrivilegeTabs] = useState("monitoring");

  const [radiusTabs, setRadiusTabs] = useState("1");
  const [showLoading, setShowLoading] = useState(false);
  const [radiusChanged, setRadiusChanged] = useState(false);
  const [privilegeChanged, setPrivilegeChanged] = useState(false);
  const [hasChanged, setHasChanged] = useState(false);

  const [alert, setAlert] = useState(null);
  const privileges = useContext(MainContext);

  const [settingValues, setSettingValues] = useState(new Map([]));

  const [privilegeValues, setPrivilegeValues] = useState(
    new Map([
      ["admin.auditing.display", "0"],
      ["admin.display", "0"],
      ["admin.logs.display", "0"],
      ["admin.sessions.display", "0"],
      ["admin.settings.display", "0"],
      ["admin.users.create", "0"],
      ["admin.users.delete", "0"],
      ["admin.users.display", "0"],
      ["admin.users.edit", "0"],
      ["admin.users.password.edit", "0"],
      ["devices.bandwidths.create", "0"],
      ["devices.bandwidths.delete", "0"],
      ["devices.bandwidths.display", "0"],
      ["devices.bandwidths.edit", "0"],
      ["devices.bandwidths.sync", "0"],
      ["devices.configurations.content.display", "0"],
      ["devices.configurations.content.download", "0"],
      ["devices.configurations.display", "0"],
      ["devices.delete", "0"],
      ["devices.details.display", "0"],
      ["devices.display", "0"],
      ["devices.endpoints.delete", "0"],
      ["devices.endpoints.details.display", "0"],
      ["devices.endpoints.display", "0"],
      ["devices.endpoints.powercycle", "0"],
      ["devices.gam.display", "0"],
      ["devices.groups.create", "0"],
      ["devices.groups.delete", "0"],
      ["devices.groups.display", "0"],
      ["devices.groups.edit", "0"],
      ["devices.ports.display", "0"],
      ["devices.subscribers.create", "0"],
      ["devices.subscribers.delete", "0"],
      ["devices.subscribers.display", "0"],
      ["devices.subscribers.edit", "0"],
      ["devices.timezones.display", "0"],
      ["devices.timezones.edit", "0"],
      ["devices.timezones.ntp.edit", "0"],
      ["firmwares.baseline.set", "0"],
      ["firmwares.delete", "0"],
      ["firmwares.display", "0"],
      ["firmwares.edit", "0"],
      ["firmwares.upload.display", "0"],
      ["versions.display", "0"],
      ["versions.licenses.display", "0"],
      ["versions.list.delete", "0"],
      ["versions.list.deploy", "0"],
      ["versions.list.display", "0"],
      ["versions.list.restart", "0"],
      ["versions.upload.display", "0"],
      ["versions.certificates.upload", "0"],
      ["others.alarms.display", "0"],
      ["others.alarms.radius.test", "0"],
      ["others.dashboard.display", "0"],
      ["notifications.display", "0"],
      ["automation.display", "0"],
      ["automations.firmware.upgrade.edit", "0"],
      ["automations.gam.configuration.display", "0"],
      ["automations.gam.configuration.edit", "0"],
      ["automations.gam.configuration.template.edit", "0"],
      ["installations.display", "0"],
      ["installations.site.list", "0"],
      ["installations.site.edit", "0"],
      ["tasks.display", "0"],
    ]),
  );

  const radiusLevel = [
    { value: "PAP", label: "PAP" },
    { value: "CHAP", label: "CHAP" },
    { value: "MSCHAPv2", label: "MS-CHAPv2" },
  ];

  const [errorMsg, setErrorMsg] = useState([]);

  const history = useHistory();

  const defaultOption =
    radiusLevel.find(
      ({ value }) => value === settingValues["radius_1_authenticator"],
    ) || radiusLevel[0];

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["admin.settings.display"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    } else {
      fetchData();
    }
  }, []);

  const fetchData = () => {
    const start = Date.now();
    fetch("/api/v1/setting/list", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        if (actualData.status == "200") {
          const settingsMap = actualData.data.settings.reduce((acc, cur) => {
            acc[cur.key] = cur.value;
            return acc;
          }, {});
          setSettingValues(settingsMap);

          const privilegesMap = actualData.data.privileges.reduce(
            (acc, cur) => {
              acc[cur.key] = cur.value;
              return acc;
            },
            {},
          );
          setPrivilegeValues(privilegesMap);
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const handleSwitchChange = (e) => {
    setHasChanged(true);
    const { props, state } = e;

    if (props.name.includes("radius")) {
      setRadiusChanged(true);
      setSettingValues({
        ...settingValues,
        [props.name]: state.value.toString(),
        ["server_restart"]: "true",
      });
    } else {
      setSettingValues({
        ...settingValues,
        [props.name]: state.value.toString(),
      });
    }
  };

  const handleInputChange = (e) => {
    setHasChanged(true);
    const { name, value } = e.target;

    if (name.includes("radius")) {
      setRadiusChanged(true);
      setSettingValues({
        ...settingValues,
        [name]: value.toString(),
        ["server_restart"]: "true",
      });
    } else {
      setSettingValues({
        ...settingValues,
        [name]: value.toString(),
      });
    }
  };

  const handleRadiusAuthenticator = (type, e) => {
    setRadiusChanged(true);
    setSettingValues({
      ...settingValues,
      [e.name]: type.value.value,
    });
  };

  const handleInputPrivilegeChange = (e) => {
    setHasChanged(true);
    const { name, value } = e.target;

    setPrivilegeChanged(true);

    setPrivilegeValues({
      ...privilegeValues,
      [name]: value.toString(),
    });
  };

  const handleTimezoneChange = (e) => {
    setHasChanged(true);
    var values = e.value.split(" ");
    setSettingValues({
      ...settingValues,
      ["timezone_hours"]: values[0],
      ["timezone_minutes"]: values[1],
      ["timezone_position"]: values[2],
    });
  };

  const handleSelect = (e, name) => {
    setHasChanged(true);
    var mode = e.value;
    setSettingValues({
      ...settingValues,
      [name]: mode.value,
    });
  };

  const handleDlMode = (dlModeOption) => {
    setHasChanged(true);
    var dlMode = dlModeOption.value;

    setSettingValues({
      ...settingValues,
      ["timezone_dl_mode"]: dlMode.value,
      ["timezone_dl_start_week"]: "",
      ["timezone_dl_end_week"]: "",
      ["timezone_dl_start_day"]: "",
      ["timezone_dl_end_day"]: "",
      ["timezone_dl_start_month"]: "",
      ["timezone_dl_end_month"]: "",
      ["timezone_dl_start_hours"]: "",
      ["timezone_dl_end_hours"]: "",
      ["timezone_dl_end_minutes"]: "",
      ["timezone_dl_start_minutes"]: "",
      ["timezone_dl_start_date"]: "",
      ["timezone_dl_end_date"]: "",
      ["timezone_dl_start_year"]: "",
      ["timezone_dl_end_year"]: "",
      ["timezone_dl_offset"]: "",
    });
  };

  const handleSubmit = () => {
    setShowLoading(true);

    fetch("/api/v1/setting/edit", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        settings: settingValues,
        privileges: privilegeValues,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.error_code) {
          setErrorMsg(actualData.error_code);
          toast.error("A problem occured while updating the settings", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        } else {
          setErrorMsg([]);
          setHasChanged(false);
          toast.success("Setting saved successfully", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
          if (radiusChanged) {
            const location = {
              pathname: "/admin/maintenance",
            };
            history.push(location);
          } else if (privilegeChanged) {
            const location = {
              pathname: "/auth/login",
            };
            history.push(location);
          }
        }
      })
      .catch((err) => {
        setShowLoading(false);
        console.log(err.message);
      });
  };

  const promptRadiusChanged = (e) => {
    e.preventDefault();
    if (radiusChanged) {
      setAlert(
        <ReactBSAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="The changes made require a restart of the Virtuoso service. Do you want to restart now?"
          onConfirm={() => handleSubmit()}
          onCancel={() => hideAlert()}
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="info"
          confirmBtnText="Yes"
          cancelBtnText="Cancel"
          showCancel
          btnSize=""
        ></ReactBSAlert>,
      );
    } else if (privilegeChanged) {
      setAlert(
        <ReactBSAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="The changes made require a log out. Do you want to continue?"
          onConfirm={() => handleSubmit()}
          onCancel={() => hideAlert()}
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="info"
          confirmBtnText="Yes"
          cancelBtnText="Cancel"
          showCancel
          btnSize=""
        ></ReactBSAlert>,
      );
    } else {
      handleSubmit();
    }
  };

  const hideAlert = () => {
    setAlert(null);
  };

  const timezonesArr = timezones.map((timezone) => ({
    ...timezone,
    value:
      timezone.offsetHours +
      " " +
      timezone.offsetMinutes +
      " " +
      timezone.position,
    label: timezone.displayTime + " " + timezone.description,
  }));

  const getRadiusAuthenticator = (name) => {
    if (!settingValues[name]) {
      return <div>Loading...</div>;
    }

    return (
      <SelectComponent
        fieldName={name}
        array={radiusLevel}
        defaultValue={radiusLevel.find(
          ({ value }) => value === settingValues[name],
        )}
        onChange={handleRadiusAuthenticator}
      />
    );
  };

  return (
    <>
      <ToastContainer />
      <div className="content">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />
        {alert}
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <DomNavLink
                      to={{
                        pathname: "/admin/dashboard",
                      }}
                    >
                      <FontAwesomeIcon icon={faHome} />
                    </DomNavLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem>Settings</BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <div className="nav-tabs-navigation">
                  <div className="nav-tabs-wrapper">
                    <Nav id="tabs" role="tablist" tabs>
                      <NavItem>
                        <NavLink
                          aria-expanded={horizontalTabs === "general"}
                          data-toggle="tab"
                          href="#"
                          role="tab"
                          className={
                            horizontalTabs === "general" ? "active" : ""
                          }
                          style={{ color: "black" }}
                          onClick={() => setHorizontalTabs("general")}
                        >
                          General
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          aria-expanded={horizontalTabs === "terms"}
                          data-toggle="tab"
                          href="#"
                          role="tab"
                          className={horizontalTabs === "terms" ? "active" : ""}
                          style={{ color: "black" }}
                          onClick={() => setHorizontalTabs("terms")}
                        >
                          Banner
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          aria-expanded={horizontalTabs === "radius"}
                          data-toggle="tab"
                          href="#"
                          role="tab"
                          className={
                            horizontalTabs === "radius" ? "active" : ""
                          }
                          style={{ color: "black" }}
                          onClick={() => setHorizontalTabs("radius")}
                        >
                          RADIUS
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          aria-expanded={horizontalTabs === "users"}
                          data-toggle="tab"
                          href="#"
                          role="tab"
                          className={horizontalTabs === "users" ? "active" : ""}
                          style={{ color: "black" }}
                          onClick={() => setHorizontalTabs("users")}
                        >
                          Users
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          aria-expanded={horizontalTabs === "tca"}
                          data-toggle="tab"
                          href="#"
                          role="tab"
                          className={horizontalTabs === "tca" ? "active" : ""}
                          style={{ color: "black" }}
                          onClick={() => setHorizontalTabs("tca")}
                        >
                          TCA
                        </NavLink>
                      </NavItem>
                      {Utilities.validateLicense(
                        sessionStorage.getItem("licenseTypes"),
                        Utilities.LICENSE_PRO,
                      ) ? (
                        <NavItem>
                          <NavLink
                            aria-expanded={horizontalTabs === "gamDaytime"}
                            data-toggle="tab"
                            href="#"
                            role="tab"
                            className={
                              horizontalTabs === "gamDaytime" ? "active" : ""
                            }
                            style={{ color: "black" }}
                            onClick={() => setHorizontalTabs("gamDaytime")}
                          >
                            GAM Date/Time
                          </NavLink>
                        </NavItem>
                      ) : (
                        ""
                      )}
                      <NavItem>
                        <NavLink
                          aria-expanded={horizontalTabs === "privileges"}
                          data-toggle="tab"
                          href="#"
                          role="tab"
                          className={
                            horizontalTabs === "privileges" ? "active" : ""
                          }
                          style={{ color: "black" }}
                          onClick={() => setHorizontalTabs("privileges")}
                        >
                          Privileges
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          aria-expanded={horizontalTabs === "email"}
                          data-toggle="tab"
                          href="#"
                          role="tab"
                          className={horizontalTabs === "email" ? "active" : ""}
                          style={{ color: "black" }}
                          onClick={() => setHorizontalTabs("email")}
                        >
                          SMTP Server
                        </NavLink>
                      </NavItem>
                    </Nav>
                  </div>
                </div>
                {errorMsg.length > 0 ? (
                  <div
                    style={{
                      backgroundColor: "#FFC0A4",
                      border: "1px solid #ef8157",
                      color: "#66615b",
                      paddingTop: "15px",
                      marginBottom: "15px",
                    }}
                  >
                    <ul>
                      {errorMsg.map((d, index) => (
                        <li key={index}>{d}</li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  ""
                )}
                <Form onSubmit={promptRadiusChanged}>
                  <TabContent
                    id="my-tab-content"
                    activeTab={horizontalTabs}
                    style={{ paddingLeft: "20px" }}
                  >
                    <TabPane tabId="general" role="tabpanel">
                      <Row>
                        <Col>
                          <h5 className="card-title">GAM</h5>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <FormGroup>
                            <label className={"settingLabel"}>
                              Configuration Backup Quantity
                            </label>
                            <Input
                              name="device_config_backup_quantity"
                              type="number"
                              onChange={handleInputChange}
                              min="0"
                              value={
                                settingValues["device_config_backup_quantity"]
                                  ? parseInt(
                                      settingValues[
                                        "device_config_backup_quantity"
                                      ],
                                    )
                                  : 0
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col></Col>
                      </Row>
                      <Row>
                        <Col>
                          <FormGroup>
                            <label className={"settingLabel"}>
                              Warning Announcement Delay (Minutes)
                            </label>
                            <Input
                              name="device_minutes_warning_active"
                              type="number"
                              onChange={handleInputChange}
                              min="2"
                              max="1440"
                              value={
                                settingValues["device_minutes_warning_active"]
                                  ? parseInt(
                                      settingValues[
                                        "device_minutes_warning_active"
                                      ],
                                    )
                                  : 0
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <label className={"settingLabel"}>
                              Error Announcement Delay (Minutes)
                            </label>
                            <Input
                              name="device_minutes_considered_active"
                              type="number"
                              onChange={handleInputChange}
                              min="2"
                              max="1440"
                              value={
                                settingValues[
                                  "device_minutes_considered_active"
                                ]
                                  ? parseInt(
                                      settingValues[
                                        "device_minutes_considered_active"
                                      ],
                                    )
                                  : 0
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <h5 className="card-title">Purge</h5>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <FormGroup>
                            <label className={"settingLabel"}>
                              Purge Audits Delay (Days)
                            </label>
                            <Input
                              name="auditing_purge_delay"
                              type="number"
                              onChange={handleInputChange}
                              min="1"
                              max="3650"
                              value={
                                settingValues["auditing_purge_delay"]
                                  ? parseInt(
                                      settingValues["auditing_purge_delay"],
                                    )
                                  : 0
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <label className={"settingLabel"}>
                              Purge Alarms Delay (Days)
                            </label>
                            <Input
                              name="alarm_purge_delay"
                              type="number"
                              onChange={handleInputChange}
                              min="1"
                              max="3650"
                              value={
                                settingValues["alarm_purge_delay"]
                                  ? parseInt(settingValues["alarm_purge_delay"])
                                  : 0
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId="terms" role="tabpanel">
                      <Row>
                        <Col>
                          <label className={"settingLabel"}>
                            Mandatory Terms Agreement
                          </label>
                          <FormGroup>
                            <Switch
                              name="general_login_mandatory_terms_agreement"
                              offColor="success"
                              offText={
                                <i className="nc-icon nc-simple-remove" />
                              }
                              onColor="success"
                              onText={<i className="nc-icon nc-check-2" />}
                              onChange={handleSwitchChange}
                              value={
                                settingValues[
                                  "general_login_mandatory_terms_agreement"
                                ] == "true"
                                  ? true
                                  : false
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <FormGroup>
                            <label className={"settingLabel"}>
                              Virtuoso Banner
                            </label>
                            <Input
                              type="textarea"
                              name="general_login_terms"
                              id="exampleText"
                              style={{ height: "150px", paddingLeft: "20px" }}
                              onChange={handleInputChange}
                              rows="15"
                              value={
                                settingValues["general_login_terms"]
                                  ? settingValues["general_login_terms"]
                                  : ""
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId="radius" role="tabpanel">
                      <Row>
                        <Col>
                          <label className={"settingLabel"}>
                            Activate RADIUS
                          </label>
                          <FormGroup>
                            <Switch
                              name="radius_activate"
                              offColor="success"
                              offText={
                                <i className="nc-icon nc-simple-remove" />
                              }
                              onColor="success"
                              onText={<i className="nc-icon nc-check-2" />}
                              onChange={handleSwitchChange}
                              value={
                                settingValues["radius_activate"] == "true"
                                  ? true
                                  : false
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <label className={"settingLabel"}>
                              Default User Inactivity Session Timeout
                            </label>
                            <Input
                              name="radius_session_timeout"
                              type="number"
                              onChange={handleInputChange}
                              min="0"
                              value={
                                settingValues["radius_session_timeout"]
                                  ? parseInt(
                                      settingValues["radius_session_timeout"],
                                    )
                                  : 0
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <div className="nav-tabs-navigation">
                            <div className="nav-tabs-wrapper">
                              <Nav id="radiusTabs" role="tablist" tabs>
                                <NavItem>
                                  <NavLink
                                    aria-expanded={radiusTabs === "1"}
                                    data-toggle="tab"
                                    href="#"
                                    role="tab"
                                    className={
                                      radiusTabs === "1" ? "active" : ""
                                    }
                                    onClick={() => setRadiusTabs("1")}
                                  >
                                    #1
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    aria-expanded={radiusTabs === "2"}
                                    data-toggle="tab"
                                    href="#"
                                    role="tab"
                                    className={
                                      radiusTabs === "2" ? "active" : ""
                                    }
                                    onClick={() => setRadiusTabs("2")}
                                  >
                                    #2
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    aria-expanded={radiusTabs === "3"}
                                    data-toggle="tab"
                                    href="#"
                                    role="tab"
                                    className={
                                      radiusTabs === "3" ? "active" : ""
                                    }
                                    onClick={() => setRadiusTabs("3")}
                                  >
                                    #3
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    aria-expanded={radiusTabs === "4"}
                                    data-toggle="tab"
                                    href="#"
                                    role="tab"
                                    className={
                                      radiusTabs === "4" ? "active" : ""
                                    }
                                    onClick={() => setRadiusTabs("4")}
                                  >
                                    #4
                                  </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    aria-expanded={radiusTabs === "5"}
                                    data-toggle="tab"
                                    href="#"
                                    role="tab"
                                    className={
                                      radiusTabs === "5" ? "active" : ""
                                    }
                                    onClick={() => setRadiusTabs("5")}
                                  >
                                    #5
                                  </NavLink>
                                </NavItem>
                              </Nav>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <TabContent
                            id="radiusTab"
                            activeTab={radiusTabs}
                            style={{ paddingLeft: "20px" }}
                          >
                            <TabPane tabId="1" role="tabpanel">
                              <Row>
                                <Col>
                                  <FormGroup>
                                    <label className={"settingLabel"}>
                                      RADIUS #1 IP address
                                    </label>
                                    <Input
                                      name="radius_1_server_ip"
                                      type="text"
                                      onChange={handleInputChange}
                                      value={
                                        settingValues["radius_1_server_ip"]
                                          ? settingValues["radius_1_server_ip"]
                                          : ""
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                                <Col>
                                  <FormGroup>
                                    <label className={"settingLabel"}>
                                      RADIUS #1 secret
                                    </label>
                                    <Input
                                      name="radius_1_secret"
                                      type="password"
                                      onChange={handleInputChange}
                                      value={
                                        settingValues["radius_1_secret"]
                                          ? settingValues["radius_1_secret"]
                                          : ""
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <FormGroup className={"settingLabel"}>
                                    {settingValues["radius_1_authenticator"] !=
                                    "" ? (
                                      <>
                                        <label className={"settingLabel"}>
                                          RADIUS #1 Authenticator
                                        </label>
                                        {getRadiusAuthenticator(
                                          "radius_1_authenticator",
                                        )}
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </FormGroup>
                                </Col>
                                <Col>
                                  <FormGroup>
                                    <label className={"settingLabel"}>
                                      RADIUS #1 Port
                                    </label>
                                    <Input
                                      name="radius_1_port"
                                      type="number"
                                      onChange={handleInputChange}
                                      min="0"
                                      value={
                                        settingValues["radius_1_port"]
                                          ? settingValues["radius_1_port"]
                                          : ""
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                            </TabPane>
                            <TabPane tabId="2" role="tabpanel">
                              <Row>
                                <Col>
                                  <FormGroup>
                                    <label className={"settingLabel"}>
                                      RADIUS #2 IP address
                                    </label>
                                    <Input
                                      name="radius_2_server_ip"
                                      type="text"
                                      onChange={handleInputChange}
                                      value={
                                        settingValues["radius_2_server_ip"]
                                          ? settingValues["radius_2_server_ip"]
                                          : ""
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                                <Col>
                                  <FormGroup>
                                    <label className={"settingLabel"}>
                                      RADIUS #2 secret
                                    </label>
                                    <Input
                                      name="radius_2_secret"
                                      type="password"
                                      onChange={handleInputChange}
                                      value={
                                        settingValues["radius_2_secret"]
                                          ? settingValues["radius_2_secret"]
                                          : ""
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <FormGroup className={"settingLabel"}>
                                    {settingValues["radius_2_authenticator"] !=
                                    "" ? (
                                      <>
                                        <label className={"settingLabel"}>
                                          RADIUS #2 Authenticator
                                        </label>
                                        {getRadiusAuthenticator(
                                          "radius_2_authenticator",
                                        )}
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </FormGroup>
                                </Col>
                                <Col>
                                  <FormGroup>
                                    <label className={"settingLabel"}>
                                      RADIUS #2 Port
                                    </label>
                                    <Input
                                      name="radius_2_port"
                                      type="number"
                                      onChange={handleInputChange}
                                      min="0"
                                      value={
                                        settingValues["radius_2_port"]
                                          ? settingValues["radius_2_port"]
                                          : ""
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                            </TabPane>
                            <TabPane tabId="3" role="tabpanel">
                              <Row>
                                <Col>
                                  <FormGroup>
                                    <label className={"settingLabel"}>
                                      RADIUS #3 IP address
                                    </label>
                                    <Input
                                      name="radius_3_server_ip"
                                      type="text"
                                      onChange={handleInputChange}
                                      value={
                                        settingValues["radius_3_server_ip"]
                                          ? settingValues["radius_3_server_ip"]
                                          : ""
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                                <Col>
                                  <FormGroup>
                                    <label className={"settingLabel"}>
                                      RADIUS #3 secret
                                    </label>
                                    <Input
                                      name="radius_3_secret"
                                      type="password"
                                      onChange={handleInputChange}
                                      value={
                                        settingValues["radius_3_secret"]
                                          ? settingValues["radius_3_secret"]
                                          : ""
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <FormGroup className={"settingLabel"}>
                                    {settingValues["radius_3_authenticator"] !=
                                    "" ? (
                                      <>
                                        <label className={"settingLabel"}>
                                          RADIUS #3 Authenticator
                                        </label>
                                        {getRadiusAuthenticator(
                                          "radius_3_authenticator",
                                        )}
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </FormGroup>
                                </Col>
                                <Col>
                                  <FormGroup>
                                    <label className={"settingLabel"}>
                                      RADIUS #3 Port
                                    </label>
                                    <Input
                                      name="radius_3_port"
                                      type="number"
                                      onChange={handleInputChange}
                                      min="0"
                                      value={
                                        settingValues["radius_3_port"]
                                          ? settingValues["radius_3_port"]
                                          : ""
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                            </TabPane>
                            <TabPane tabId="4" role="tabpanel">
                              <Row>
                                <Col>
                                  <FormGroup>
                                    <label className={"settingLabel"}>
                                      RADIUS #4 IP address
                                    </label>
                                    <Input
                                      name="radius_4_server_ip"
                                      type="text"
                                      onChange={handleInputChange}
                                      value={
                                        settingValues["radius_4_server_ip"]
                                          ? settingValues["radius_4_server_ip"]
                                          : ""
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                                <Col>
                                  <FormGroup>
                                    <label className={"settingLabel"}>
                                      RADIUS #4 secret
                                    </label>
                                    <Input
                                      name="radius_4_secret"
                                      type="password"
                                      onChange={handleInputChange}
                                      value={
                                        settingValues["radius_4_secret"]
                                          ? settingValues["radius_4_secret"]
                                          : ""
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <FormGroup className={"settingLabel"}>
                                    {settingValues["radius_4_authenticator"] !=
                                    "" ? (
                                      <>
                                        <label className={"settingLabel"}>
                                          RADIUS #4 Authenticator
                                        </label>
                                        {getRadiusAuthenticator(
                                          "radius_4_authenticator",
                                        )}
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </FormGroup>
                                </Col>
                                <Col>
                                  <FormGroup>
                                    <label className={"settingLabel"}>
                                      RADIUS #4 Port
                                    </label>
                                    <Input
                                      name="radius_4_port"
                                      type="number"
                                      onChange={handleInputChange}
                                      min="0"
                                      value={
                                        settingValues["radius_4_port"]
                                          ? settingValues["radius_4_port"]
                                          : ""
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                            </TabPane>
                            <TabPane tabId="5" role="tabpanel">
                              <Row>
                                <Col>
                                  <FormGroup>
                                    <label className={"settingLabel"}>
                                      RADIUS #5 IP address
                                    </label>
                                    <Input
                                      name="radius_5_server_ip"
                                      type="text"
                                      onChange={handleInputChange}
                                      value={
                                        settingValues["radius_5_server_ip"]
                                          ? settingValues["radius_5_server_ip"]
                                          : ""
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                                <Col>
                                  <FormGroup>
                                    <label className={"settingLabel"}>
                                      RADIUS #5 secret
                                    </label>
                                    <Input
                                      name="radius_5_secret"
                                      type="password"
                                      onChange={handleInputChange}
                                      value={
                                        settingValues["radius_5_secret"]
                                          ? settingValues["radius_5_secret"]
                                          : ""
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <FormGroup className={"settingLabel"}>
                                    {settingValues["radius_5_authenticator"] !=
                                    "" ? (
                                      <>
                                        <label className={"settingLabel"}>
                                          RADIUS #5 Authenticator
                                        </label>
                                        {getRadiusAuthenticator(
                                          "radius_5_authenticator",
                                        )}
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </FormGroup>
                                </Col>
                                <Col>
                                  <FormGroup>
                                    <label className={"settingLabel"}>
                                      RADIUS #5 Port
                                    </label>
                                    <Input
                                      name="radius_5_port"
                                      type="number"
                                      onChange={handleInputChange}
                                      min="0"
                                      value={
                                        settingValues["radius_5_port"]
                                          ? settingValues["radius_5_port"]
                                          : ""
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                            </TabPane>
                          </TabContent>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId="users" role="tabpanel">
                      <Row>
                        <Col>
                          <label className={"settingLabel"}>
                            Convert Date With User Timezone
                          </label>
                          <FormGroup>
                            <Switch
                              name="general_convert_date_with_user_timezone"
                              offColor="success"
                              offText={
                                <i className="nc-icon nc-simple-remove" />
                              }
                              onColor="success"
                              onText={<i className="nc-icon nc-check-2" />}
                              onChange={handleSwitchChange}
                              value={
                                settingValues[
                                  "general_convert_date_with_user_timezone"
                                ] == "true"
                                  ? true
                                  : false
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <label className={"settingLabel"}>
                            Activate Groups Access Mode
                          </label>
                          <FormGroup>
                            <Switch
                              name="activate_group_access_mode"
                              offColor="success"
                              offText={
                                <i className="nc-icon nc-simple-remove" />
                              }
                              onColor="success"
                              onText={<i className="nc-icon nc-check-2" />}
                              onChange={handleSwitchChange}
                              value={
                                settingValues["activate_group_access_mode"] ==
                                "true"
                                  ? true
                                  : false
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col></Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId="tca" role="tabpanel">
                      <Row>
                        <Col>
                          <FormGroup>
                            <label className={"settingLabel"}>
                              Max Usable Bandwidth (Mbps) - Warning Level
                            </label>
                            <Input
                              name="endpoint_details_tca_bandwidth_warning_level"
                              type="number"
                              onChange={handleInputChange}
                              min="0"
                              value={
                                settingValues[
                                  "endpoint_details_tca_bandwidth_warning_level"
                                ]
                                  ? parseInt(
                                      settingValues[
                                        "endpoint_details_tca_bandwidth_warning_level"
                                      ],
                                    )
                                  : 0
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <label className={"settingLabel"}>
                              Max Usable Bandwidth (Mbps) - Error Level
                            </label>
                            <Input
                              name="endpoint_details_tca_bandwidth_error_level"
                              type="number"
                              onChange={handleInputChange}
                              min="0"
                              value={
                                settingValues[
                                  "endpoint_details_tca_bandwidth_error_level"
                                ]
                                  ? parseInt(
                                      settingValues[
                                        "endpoint_details_tca_bandwidth_error_level"
                                      ],
                                    )
                                  : 0
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <FormGroup>
                            <label className={"settingLabel"}>
                              PHY rate (Mbps) - Warning Level
                            </label>
                            <Input
                              name="endpoint_details_tca_phy_warning_level"
                              type="number"
                              onChange={handleInputChange}
                              min="0"
                              value={
                                settingValues[
                                  "endpoint_details_tca_phy_warning_level"
                                ]
                                  ? parseInt(
                                      settingValues[
                                        "endpoint_details_tca_phy_warning_level"
                                      ],
                                    )
                                  : 0
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <label className={"settingLabel"}>
                              PHY rate (Mbps) - Error Level
                            </label>
                            <Input
                              name="endpoint_details_tca_phy_error_level"
                              type="number"
                              onChange={handleInputChange}
                              min="0"
                              value={
                                settingValues[
                                  "endpoint_details_tca_phy_error_level"
                                ]
                                  ? parseInt(
                                      settingValues[
                                        "endpoint_details_tca_phy_error_level"
                                      ],
                                    )
                                  : 0
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <FormGroup>
                            <label className={"settingLabel"}>
                              Maximum number of coax endpoints per G.hn port -
                              Warning Level
                            </label>
                            <Input
                              name="maximum_number_coax_endpoints_tca_warning_level"
                              type="number"
                              onChange={handleInputChange}
                              min="0"
                              value={
                                settingValues[
                                  "maximum_number_coax_endpoints_tca_warning_level"
                                ]
                                  ? parseInt(
                                      settingValues[
                                        "maximum_number_coax_endpoints_tca_warning_level"
                                      ],
                                    )
                                  : 0
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <label className={"settingLabel"}>
                              Maximum number of coax endpoints per G.hn port -
                              Error Level
                            </label>
                            <Input
                              name="maximum_number_coax_endpoints_tca_error_level"
                              type="number"
                              onChange={handleInputChange}
                              min="0"
                              value={
                                settingValues[
                                  "maximum_number_coax_endpoints_tca_error_level"
                                ]
                                  ? parseInt(
                                      settingValues[
                                        "maximum_number_coax_endpoints_tca_error_level"
                                      ],
                                    )
                                  : 0
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId="gamDaytime" role="tabpanel">
                      <div className="nav-tabs-navigation">
                        <div className="nav-tabs-wrapper">
                          <Nav id="tabs" role="tablist" tabs>
                            <NavItem>
                              <NavLink
                                aria-expanded={gamDaytimeTabs === "gamTimezone"}
                                data-toggle="tab"
                                href="#"
                                role="tab"
                                className={
                                  gamDaytimeTabs === "gamTimezone"
                                    ? "active"
                                    : ""
                                }
                                style={{ color: "black" }}
                                onClick={() => setGamDaytimeTabs("gamTimezone")}
                              >
                                Time Zone
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                aria-expanded={gamDaytimeTabs === "gamNtp"}
                                data-toggle="tab"
                                href="#"
                                role="tab"
                                className={
                                  gamDaytimeTabs === "gamNtp" ? "active" : ""
                                }
                                style={{ color: "black" }}
                                onClick={() => setGamDaytimeTabs("gamNtp")}
                              >
                                NTP
                              </NavLink>
                            </NavItem>
                          </Nav>
                        </div>
                      </div>
                      <TabContent
                        id="tabGamDaytimeContent"
                        activeTab={gamDaytimeTabs}
                        style={{ paddingLeft: "20px" }}
                      >
                        <TabPane tabId="gamTimezone" role="tabpanel">
                          <Row>
                            <Col>
                              <label className={"settingLabel"}>
                                Enable GAMS time zone automation
                              </label>
                              <FormGroup>
                                <Switch
                                  name="timezone_automation"
                                  offColor="success"
                                  offText={
                                    <i className="nc-icon nc-simple-remove" />
                                  }
                                  onColor="success"
                                  onText={<i className="nc-icon nc-check-2" />}
                                  onChange={handleSwitchChange}
                                  value={
                                    settingValues["timezone_automation"] ==
                                    "true"
                                      ? true
                                      : false
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          {settingValues["timezone_automation"] == "true" ? (
                            <>
                              <Row>
                                <Col>
                                  <label>Time Zone</label>
                                  <FormGroup className={"settingLabel"}>
                                    <Select
                                      className="react-select primary"
                                      classNamePrefix="react-select"
                                      name="filterButton"
                                      onChange={(option) => {
                                        handleTimezoneChange(option);
                                      }}
                                      defaultValue={timezonesArr.find(
                                        (timezone) =>
                                          timezone.value ===
                                          settingValues["timezone_hours"] +
                                            " " +
                                            settingValues["timezone_minutes"] +
                                            " " +
                                            settingValues["timezone_position"],
                                      )}
                                      options={timezonesArr}
                                    />
                                  </FormGroup>
                                </Col>
                                <Col>
                                  <SelectComponent
                                    label="Daylight Saving Time Mode"
                                    fieldName={"timezone_dl_mode"}
                                    array={daylightMode}
                                    defaultValue={daylightMode.find(
                                      ({ value }) =>
                                        value ===
                                        settingValues["timezone_dl_mode"],
                                    )}
                                    onChange={(option) => {
                                      handleDlMode(option);
                                    }}
                                  />
                                </Col>
                                <Col>
                                  <label>Acronym</label>
                                  <FormGroup className={"settingLabel"}>
                                    <Input
                                      type="text"
                                      name="timezone_acronym"
                                      onChange={handleInputChange}
                                      value={settingValues["timezone_acronym"]}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              {settingValues["timezone_dl_mode"] ==
                              "recurring" ? (
                                <Row>
                                  <Col>
                                    <Row>
                                      <Col>
                                        <h5>Start Date</h5>
                                        <SelectComponent
                                          label="Week #"
                                          fieldName={"timezone_dl_start_week"}
                                          array={daylightWeekNumbers}
                                          onChange={(option) => {
                                            handleSelect(
                                              option,
                                              "timezone_dl_start_week",
                                            );
                                          }}
                                          defaultValue={daylightWeekNumbers.find(
                                            ({ value }) =>
                                              value ===
                                              settingValues[
                                                "timezone_dl_start_week"
                                              ],
                                          )}
                                        />
                                        <SelectComponent
                                          label="Day"
                                          fieldName={"timezone_dl_start_day"}
                                          array={weekdays}
                                          onChange={(option) => {
                                            handleSelect(
                                              option,
                                              "timezone_dl_start_day",
                                            );
                                          }}
                                          defaultValue={weekdays.find(
                                            ({ value }) =>
                                              value ===
                                              settingValues[
                                                "timezone_dl_start_day"
                                              ],
                                          )}
                                        />
                                        <SelectComponent
                                          label="Month"
                                          fieldName={"timezone_dl_start_month"}
                                          array={months}
                                          onChange={(option) => {
                                            handleSelect(
                                              option,
                                              "timezone_dl_start_month",
                                            );
                                          }}
                                          defaultValue={months.find(
                                            ({ value }) =>
                                              value ===
                                              settingValues[
                                                "timezone_dl_start_month"
                                              ],
                                          )}
                                        />
                                        <SelectComponent
                                          label="Hours"
                                          fieldName={"timezone_dl_start_hours"}
                                          array={hours}
                                          onChange={(option) => {
                                            handleSelect(
                                              option,
                                              "timezone_dl_start_hours",
                                            );
                                          }}
                                          defaultValue={hours.find(
                                            ({ value }) =>
                                              value ===
                                              settingValues[
                                                "timezone_dl_start_hours"
                                              ],
                                          )}
                                        />
                                        <SelectComponent
                                          label="Minutes"
                                          fieldName={
                                            "timezone_dl_start_minutes"
                                          }
                                          array={daylightMinutes}
                                          onChange={(option) => {
                                            handleSelect(
                                              option,
                                              "timezone_dl_start_minutes",
                                            );
                                          }}
                                          defaultValue={daylightMinutes.find(
                                            ({ value }) =>
                                              value ===
                                              settingValues[
                                                "timezone_dl_start_minutes"
                                              ],
                                          )}
                                        />
                                        <SelectComponent
                                          label="Offset"
                                          fieldName={"timezone_dl_offset"}
                                          array={offsetMinutes}
                                          onChange={(option) => {
                                            handleSelect(
                                              option,
                                              "timezone_dl_offset",
                                            );
                                          }}
                                          defaultValue={offsetMinutes.find(
                                            ({ value }) =>
                                              value ===
                                              settingValues[
                                                "timezone_dl_offset"
                                              ],
                                          )}
                                        />
                                      </Col>
                                    </Row>
                                  </Col>
                                  <Col>
                                    <Row>
                                      <Col>
                                        <h5>End Date</h5>
                                        <SelectComponent
                                          label="Week #"
                                          fieldName={"timezone_dl_end_week"}
                                          array={daylightWeekNumbers}
                                          onChange={(option) => {
                                            handleSelect(
                                              option,
                                              "timezone_dl_end_week",
                                            );
                                          }}
                                          defaultValue={daylightWeekNumbers.find(
                                            ({ value }) =>
                                              value ===
                                              settingValues[
                                                "timezone_dl_end_week"
                                              ],
                                          )}
                                        />
                                        <SelectComponent
                                          label="Day"
                                          fieldName={"timezone_dl_end_day"}
                                          array={weekdays}
                                          onChange={(option) => {
                                            handleSelect(
                                              option,
                                              "timezone_dl_end_day",
                                            );
                                          }}
                                          defaultValue={weekdays.find(
                                            ({ value }) =>
                                              value ===
                                              settingValues[
                                                "timezone_dl_end_day"
                                              ],
                                          )}
                                        />
                                        <SelectComponent
                                          label="Month"
                                          fieldName={"timezone_dl_end_month"}
                                          array={months}
                                          onChange={(option) => {
                                            handleSelect(
                                              option,
                                              "timezone_dl_end_month",
                                            );
                                          }}
                                          defaultValue={months.find(
                                            ({ value }) =>
                                              value ===
                                              settingValues[
                                                "timezone_dl_end_month"
                                              ],
                                          )}
                                        />
                                        <SelectComponent
                                          label="Hours"
                                          fieldName={"timezone_dl_end_hours"}
                                          array={hours}
                                          onChange={(option) => {
                                            handleSelect(
                                              option,
                                              "timezone_dl_end_hours",
                                            );
                                          }}
                                          defaultValue={hours.find(
                                            ({ value }) =>
                                              value ===
                                              settingValues[
                                                "timezone_dl_end_hours"
                                              ],
                                          )}
                                        />
                                        <SelectComponent
                                          label="Minutes"
                                          fieldName={"timezone_dl_end_minutes"}
                                          array={daylightMinutes}
                                          onChange={(option) => {
                                            handleSelect(
                                              option,
                                              "timezone_dl_end_minutes",
                                            );
                                          }}
                                          defaultValue={daylightMinutes.find(
                                            ({ value }) =>
                                              value ===
                                              settingValues[
                                                "timezone_dl_end_minutes"
                                              ],
                                          )}
                                        />
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              ) : (
                                ""
                              )}
                              {settingValues["timezone_dl_mode"] ==
                              "nonRecurring" ? (
                                <Row>
                                  <Col>
                                    <Row>
                                      <Col>
                                        <h5>Start Date</h5>
                                        <SelectComponent
                                          label="Month"
                                          fieldName={"timezone_dl_start_month"}
                                          array={months}
                                          onChange={(option) => {
                                            handleSelect(
                                              option,
                                              "timezone_dl_start_month",
                                            );
                                          }}
                                          defaultValue={months.find(
                                            ({ value }) =>
                                              value ===
                                              settingValues[
                                                "timezone_dl_start_month"
                                              ],
                                          )}
                                        />
                                        <SelectComponent
                                          label="Date"
                                          fieldName={"timezone_dl_start_date"}
                                          array={Array.from(
                                            { length: 31 },
                                            (_, index) => ({
                                              value: index + 1,
                                              label: index + 1,
                                            }),
                                          )}
                                          onChange={(option) => {
                                            handleSelect(
                                              option,
                                              "timezone_dl_start_date",
                                            );
                                          }}
                                        />
                                        <SelectComponent
                                          label="Year"
                                          fieldName={"timezone_dl_start_year"}
                                          array={Array(98)
                                            .fill()
                                            .map((_, index) => {
                                              const year = 2000 + index;
                                              return {
                                                value: year.toString(),
                                                label: year.toString(),
                                              };
                                            })}
                                          onChange={(option) => {
                                            handleSelect(
                                              option,
                                              "timezone_dl_start_year",
                                            );
                                          }}
                                        />
                                        <SelectComponent
                                          label="Hours"
                                          fieldName={"timezone_dl_start_hours"}
                                          array={hours}
                                          onChange={(option) => {
                                            handleSelect(
                                              option,
                                              "timezone_dl_start_hours",
                                            );
                                          }}
                                          defaultValue={hours.find(
                                            ({ value }) =>
                                              value ===
                                              settingValues[
                                                "timezone_dl_start_hours"
                                              ],
                                          )}
                                        />
                                        <SelectComponent
                                          label="Minutes"
                                          fieldName={
                                            "timezone_dl_start_minutes"
                                          }
                                          array={daylightMinutes}
                                          onChange={(option) => {
                                            handleSelect(
                                              option,
                                              "timezone_dl_start_minutes",
                                            );
                                          }}
                                          defaultValue={daylightMinutes.find(
                                            ({ value }) =>
                                              value ===
                                              settingValues[
                                                "timezone_dl_start_minutes"
                                              ],
                                          )}
                                        />
                                        <SelectComponent
                                          label="Offset"
                                          fieldName={"timezone_dl_offset"}
                                          array={offsetMinutes}
                                          onChange={(option) => {
                                            handleSelect(
                                              option,
                                              "timezone_dl_offset",
                                            );
                                          }}
                                        />
                                      </Col>
                                    </Row>
                                  </Col>
                                  <Col>
                                    <Row>
                                      <Col>
                                        <h5>End Date</h5>
                                        <SelectComponent
                                          label="Month"
                                          fieldName={"timezone_dl_end_month"}
                                          array={months}
                                          onChange={(option) => {
                                            handleSelect(
                                              option,
                                              "timezone_dl_end_month",
                                            );
                                          }}
                                          defaultValue={months.find(
                                            ({ value }) =>
                                              value ===
                                              settingValues[
                                                "timezone_dl_end_month"
                                              ],
                                          )}
                                        />
                                        <SelectComponent
                                          label="Date"
                                          fieldName={"timezone_dl_end_date"}
                                          array={Array.from(
                                            { length: 31 },
                                            (_, index) => ({
                                              value: index + 1,
                                              label: index + 1,
                                            }),
                                          )}
                                          onChange={(option) => {
                                            handleSelect(
                                              option,
                                              "timezone_dl_end_date",
                                            );
                                          }}
                                        />
                                        <SelectComponent
                                          label="Year"
                                          fieldName={"timezone_dl_end_year"}
                                          array={Array(98)
                                            .fill()
                                            .map((_, index) => {
                                              const year = 2000 + index;
                                              return {
                                                value: year.toString(),
                                                label: year.toString(),
                                              };
                                            })}
                                          onChange={(option) => {
                                            handleSelect(
                                              option,
                                              "timezone_dl_end_year",
                                            );
                                          }}
                                        />
                                        <SelectComponent
                                          label="Hours"
                                          fieldName={"timezone_dl_end_hours"}
                                          array={hours}
                                          onChange={(option) => {
                                            handleSelect(
                                              option,
                                              "timezone_dl_end_hours",
                                            );
                                          }}
                                          defaultValue={hours.find(
                                            ({ value }) =>
                                              value ===
                                              settingValues[
                                                "timezone_dl_end_hours"
                                              ],
                                          )}
                                        />
                                        <SelectComponent
                                          label="Minutes"
                                          fieldName={"timezone_dl_end_minutes"}
                                          array={daylightMinutes}
                                          onChange={(option) => {
                                            handleSelect(
                                              option,
                                              "timezone_dl_end_minutes",
                                            );
                                          }}
                                          defaultValue={daylightMinutes.find(
                                            ({ value }) =>
                                              value ===
                                              settingValues[
                                                "timezone_dl_end_minutes"
                                              ],
                                          )}
                                        />
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              ) : (
                                ""
                              )}
                            </>
                          ) : (
                            ""
                          )}
                        </TabPane>
                        <TabPane tabId="gamNtp" role="tabpanel">
                          <Row>
                            <Col>
                              <label className={"settingLabel"}>
                                Enable NTP servers automation
                              </label>
                              <FormGroup>
                                <Switch
                                  name="ntp_automation"
                                  offColor="success"
                                  offText={
                                    <i className="nc-icon nc-simple-remove" />
                                  }
                                  onColor="success"
                                  onText={<i className="nc-icon nc-check-2" />}
                                  onChange={handleSwitchChange}
                                  value={
                                    settingValues["ntp_automation"] == "true"
                                      ? true
                                      : false
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col></Col>
                          </Row>
                          <Row>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Server #1
                                </label>
                                <Input
                                  type="text"
                                  name="ntp_server_1"
                                  onChange={handleInputChange}
                                  value={
                                    settingValues["ntp_server_1"]
                                      ? settingValues["ntp_server_1"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Server #2
                                </label>
                                <Input
                                  type="text"
                                  name="ntp_server_2"
                                  onChange={handleInputChange}
                                  value={
                                    settingValues["ntp_server_2"]
                                      ? settingValues["ntp_server_2"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Server #3
                                </label>
                                <Input
                                  type="text"
                                  name="ntp_server_3"
                                  onChange={handleInputChange}
                                  value={
                                    settingValues["ntp_server_3"]
                                      ? settingValues["ntp_server_3"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Server #4
                                </label>
                                <Input
                                  type="text"
                                  name="ntp_server_4"
                                  onChange={handleInputChange}
                                  value={
                                    settingValues["ntp_server_4"]
                                      ? settingValues["ntp_server_4"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Server #5
                                </label>
                                <Input
                                  type="text"
                                  name="ntp_server_5"
                                  onChange={handleInputChange}
                                  value={
                                    settingValues["ntp_server_5"]
                                      ? settingValues["ntp_server_5"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col></Col>
                          </Row>
                        </TabPane>
                      </TabContent>
                    </TabPane>
                    <TabPane tabId="privileges" role="tabpanel">
                      <div className="nav-tabs-navigation">
                        <div className="nav-tabs-wrapper">
                          <Nav id="tabs" role="tablist" tabs>
                            <NavItem>
                              <NavLink
                                aria-expanded={privilegeTabs === "monitoring"}
                                data-toggle="tab"
                                href="#"
                                role="tab"
                                className={
                                  privilegeTabs === "monitoring" ? "active" : ""
                                }
                                style={{ color: "black" }}
                                onClick={() => setPrivilegeTabs("monitoring")}
                              >
                                Monitoring
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                aria-expanded={privilegeTabs === "services"}
                                data-toggle="tab"
                                href="#"
                                role="tab"
                                className={
                                  privilegeTabs === "services" ? "active" : ""
                                }
                                style={{ color: "black" }}
                                onClick={() => setPrivilegeTabs("services")}
                              >
                                Services
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                aria-expanded={privilegeTabs === "automation"}
                                data-toggle="tab"
                                href="#"
                                role="tab"
                                className={
                                  privilegeTabs === "automation" ? "active" : ""
                                }
                                style={{ color: "black" }}
                                onClick={() => setPrivilegeTabs("automation")}
                              >
                                Automation
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                aria-expanded={privilegeTabs === "devices"}
                                data-toggle="tab"
                                href="#"
                                role="tab"
                                className={
                                  privilegeTabs === "devices" ? "active" : ""
                                }
                                style={{ color: "black" }}
                                onClick={() => setPrivilegeTabs("devices")}
                              >
                                Devices
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                aria-expanded={privilegeTabs === "versions"}
                                data-toggle="tab"
                                href="#"
                                role="tab"
                                className={
                                  privilegeTabs === "versions" ? "active" : ""
                                }
                                style={{ color: "black" }}
                                onClick={() => setPrivilegeTabs("versions")}
                              >
                                Versions
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                aria-expanded={privilegeTabs === "admin"}
                                data-toggle="tab"
                                href="#"
                                role="tab"
                                className={
                                  privilegeTabs === "admin" ? "active" : ""
                                }
                                style={{ color: "black" }}
                                onClick={() => setPrivilegeTabs("admin")}
                              >
                                Admin
                              </NavLink>
                            </NavItem>
                          </Nav>
                        </div>
                      </div>
                      <TabContent
                        id="tabPrivilegesContent"
                        activeTab={privilegeTabs}
                        style={{ paddingLeft: "20px" }}
                      >
                        <TabPane tabId="admin" role="tabpanel">
                          <Row>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Active Sessions Display
                                </label>
                                <Input
                                  name="admin.sessions.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["admin.sessions.display"]
                                      ? privilegeValues[
                                          "admin.sessions.display"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Admin Menu Display
                                </label>
                                <Input
                                  name="admin.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["admin.display"]
                                      ? privilegeValues["admin.display"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Auditing Display
                                </label>
                                <Input
                                  name="admin.auditing.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["admin.auditing.display"]
                                      ? privilegeValues[
                                          "admin.auditing.display"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>

                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Logs Display
                                </label>
                                <Input
                                  name="admin.logs.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["admin.logs.display"]
                                      ? privilegeValues["admin.logs.display"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>

                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Settings Display
                                </label>
                                <Input
                                  name="admin.settings.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["admin.settings.display"]
                                      ? privilegeValues[
                                          "admin.settings.display"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  User Create
                                </label>
                                <Input
                                  name="admin.users.create"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["admin.users.create"]
                                      ? privilegeValues["admin.users.create"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  User Delete
                                </label>
                                <Input
                                  name="admin.users.delete"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["admin.users.delete"]
                                      ? privilegeValues["admin.users.delete"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  User Display
                                </label>
                                <Input
                                  name="admin.users.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["admin.users.display"]
                                      ? privilegeValues["admin.users.display"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  User Edit
                                </label>
                                <Input
                                  name="admin.users.edit"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["admin.users.edit"]
                                      ? privilegeValues["admin.users.edit"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  User Password Edit
                                </label>
                                <Input
                                  name="admin.users.password.edit"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["admin.users.password.edit"]
                                      ? privilegeValues[
                                          "admin.users.password.edit"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Notification Display
                                </label>
                                <Input
                                  name="notifications.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["notifications.display"]
                                      ? privilegeValues["notifications.display"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Scheduled Task Display
                                </label>
                                <Input
                                  name="tasks.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["tasks.display"]
                                      ? privilegeValues["tasks.display"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col></Col>
                            <Col></Col>
                            <Col></Col>
                          </Row>
                        </TabPane>
                        <TabPane tabId="devices" role="tabpanel">
                          <Row>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Configuration Content
                                </label>
                                <Input
                                  name="devices.configurations.content.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues[
                                      "devices.configurations.content.display"
                                    ]
                                      ? privilegeValues[
                                          "devices.configurations.content.display"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Configuration Content Download
                                </label>
                                <Input
                                  name="devices.configurations.content.download"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues[
                                      "devices.configurations.content.download"
                                    ]
                                      ? privilegeValues[
                                          "devices.configurations.content.download"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Configuration Display
                                </label>
                                <Input
                                  name="devices.configurations.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues[
                                      "devices.configurations.display"
                                    ]
                                      ? privilegeValues[
                                          "devices.configurations.display"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Device Delete
                                </label>
                                <Input
                                  name="devices.delete"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["devices.delete"]
                                      ? privilegeValues["devices.delete"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Device Details Display
                                </label>
                                <Input
                                  name="devices.details.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["devices.details.display"]
                                      ? privilegeValues[
                                          "devices.details.display"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Device URL Announcement
                                </label>
                                <Input
                                  name="devices.url.announcement"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["devices.url.announcement"]
                                      ? privilegeValues[
                                          "devices.url.announcement"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Device Display
                                </label>
                                <Input
                                  name="devices.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["devices.display"]
                                      ? privilegeValues["devices.display"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Endpoint Delete
                                </label>
                                <Input
                                  name="devices.endpoints.delete"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["devices.endpoints.delete"]
                                      ? privilegeValues[
                                          "devices.endpoints.delete"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Endpoint Details Display
                                </label>
                                <Input
                                  name="devices.endpoints.details.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues[
                                      "devices.endpoints.details.display"
                                    ]
                                      ? privilegeValues[
                                          "devices.endpoints.details.display"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Endpoint Display
                                </label>
                                <Input
                                  name="devices.endpoints.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["devices.endpoints.display"]
                                      ? privilegeValues[
                                          "devices.endpoints.display"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Endpoint Power Cycle
                                </label>
                                <Input
                                  name="devices.endpoints.powercycle"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues[
                                      "devices.endpoints.powercycle"
                                    ]
                                      ? privilegeValues[
                                          "devices.endpoints.powercycle"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Endpoint Reboot
                                </label>
                                <Input
                                  name="devices.endpoints.reboot"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["devices.endpoints.reboot"]
                                      ? privilegeValues[
                                          "devices.endpoints.reboot"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  GAM Display
                                </label>
                                <Input
                                  name="devices.gam.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["devices.gam.display"]
                                      ? privilegeValues["devices.gam.display"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Group Create
                                </label>
                                <Input
                                  name="devices.groups.create"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["devices.groups.create"]
                                      ? privilegeValues["devices.groups.create"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Group Delete
                                </label>
                                <Input
                                  name="devices.groups.delete"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["devices.groups.delete"]
                                      ? privilegeValues["devices.groups.delete"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Group Display
                                </label>
                                <Input
                                  name="devices.groups.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["devices.groups.display"]
                                      ? privilegeValues[
                                          "devices.groups.display"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Group Edit
                                </label>
                                <Input
                                  name="devices.groups.edit"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["devices.groups.edit"]
                                      ? privilegeValues["devices.groups.edit"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Ports Display
                                </label>
                                <Input
                                  name="devices.ports.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["devices.ports.display"]
                                      ? privilegeValues["devices.ports.display"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Subscriber Display
                                </label>
                                <Input
                                  name="devices.subscribers.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues[
                                      "devices.subscribers.display"
                                    ]
                                      ? privilegeValues[
                                          "devices.subscribers.display"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Subscriber Edit
                                </label>
                                <Input
                                  name="devices.subscribers.edit"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["devices.subscribers.edit"]
                                      ? privilegeValues[
                                          "devices.subscribers.edit"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Timezone Display
                                </label>
                                <Input
                                  name="devices.timezones.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["devices.timezones.display"]
                                      ? privilegeValues[
                                          "devices.timezones.display"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Timezone Edit
                                </label>
                                <Input
                                  name="devices.timezones.edit"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["devices.timezones.edit"]
                                      ? privilegeValues[
                                          "devices.timezones.edit"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Timezone NTP Edit
                                </label>
                                <Input
                                  name="devices.timezones.ntp.edit"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues[
                                      "devices.timezones.ntp.edit"
                                    ]
                                      ? privilegeValues[
                                          "devices.timezones.ntp.edit"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Firmware Baseline Set/Unset
                                </label>
                                <Input
                                  name="firmwares.baseline.set"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["firmwares.baseline.set"]
                                      ? privilegeValues[
                                          "firmwares.baseline.set"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Firmware Delete
                                </label>
                                <Input
                                  name="firmwares.delete"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["firmwares.delete"]
                                      ? privilegeValues["firmwares.delete"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Firmware Display
                                </label>
                                <Input
                                  name="firmwares.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["firmwares.display"]
                                      ? privilegeValues["firmwares.display"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Firmware Edit
                                </label>
                                <Input
                                  name="firmwares.edit"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["firmwares.edit"]
                                      ? privilegeValues["firmwares.edit"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Firmware Upload
                                </label>
                                <Input
                                  name="firmwares.upload.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["firmwares.upload.display"]
                                      ? privilegeValues[
                                          "firmwares.upload.display"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col></Col>
                            <Col></Col>
                          </Row>
                        </TabPane>
                        <TabPane tabId="versions" role="tabpanel">
                          <Row>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Version Menu Display
                                </label>
                                <Input
                                  name="versions.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["versions.display"]
                                      ? privilegeValues["versions.display"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Version Licenses Display
                                </label>
                                <Input
                                  name="versions.licenses.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["versions.licenses.display"]
                                      ? privilegeValues[
                                          "versions.licenses.display"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Version Delete
                                </label>
                                <Input
                                  name="versions.list.delete"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["versions.list.delete"]
                                      ? privilegeValues["versions.list.delete"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Version Deploy
                                </label>
                                <Input
                                  name="versions.list.deploy"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["versions.list.deploy"]
                                      ? privilegeValues["versions.list.deploy"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Version List Display
                                </label>
                                <Input
                                  name="versions.list.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["versions.list.display"]
                                      ? privilegeValues["versions.list.display"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Version Restart
                                </label>
                                <Input
                                  name="versions.list.restart"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["versions.list.restart"]
                                      ? privilegeValues["versions.list.restart"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Version Upload
                                </label>
                                <Input
                                  name="versions.upload.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["versions.upload.display"]
                                      ? privilegeValues[
                                          "versions.upload.display"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Certificates Upload
                                </label>
                                <Input
                                  name="versions.certificates.upload"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues[
                                      "versions.certificates.upload"
                                    ]
                                      ? privilegeValues[
                                          "versions.certificates.upload"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col></Col>
                            <Col></Col>
                          </Row>
                        </TabPane>
                        <TabPane tabId="services" role="tabpanel">
                          <Row>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Bandwidth Create
                                </label>
                                <Input
                                  name="devices.bandwidths.create"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["devices.bandwidths.create"]
                                      ? privilegeValues[
                                          "devices.bandwidths.create"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Bandwidth Delete
                                </label>
                                <Input
                                  name="devices.bandwidths.delete"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["devices.bandwidths.delete"]
                                      ? privilegeValues[
                                          "devices.bandwidths.delete"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Bandwidth Display
                                </label>
                                <Input
                                  name="devices.bandwidths.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues[
                                      "devices.bandwidths.display"
                                    ]
                                      ? privilegeValues[
                                          "devices.bandwidths.display"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Bandwidth Edit
                                </label>
                                <Input
                                  name="devices.bandwidths.edit"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["devices.bandwidths.edit"]
                                      ? privilegeValues[
                                          "devices.bandwidths.edit"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col></Col>
                          </Row>
                          <Row>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Subscriber Create
                                </label>
                                <Input
                                  name="devices.subscribers.create"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues[
                                      "devices.subscribers.create"
                                    ]
                                      ? privilegeValues[
                                          "devices.subscribers.create"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Subscriber Delete
                                </label>
                                <Input
                                  name="devices.subscribers.delete"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues[
                                      "devices.subscribers.delete"
                                    ]
                                      ? privilegeValues[
                                          "devices.subscribers.delete"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Subscriber Details Display
                                </label>
                                <Input
                                  name="devices.subscribers.details.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues[
                                      "devices.subscribers.details.display"
                                    ]
                                      ? privilegeValues[
                                          "devices.subscribers.details.display"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Subscriber Display
                                </label>
                                <Input
                                  name="devices.subscribers.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues[
                                      "devices.subscribers.display"
                                    ]
                                      ? privilegeValues[
                                          "devices.subscribers.display"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Subscriber Edit
                                </label>
                                <Input
                                  name="devices.subscribers.edit"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["devices.subscribers.edit"]
                                      ? privilegeValues[
                                          "devices.subscribers.edit"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </TabPane>
                        <TabPane tabId="automation" role="tabpanel">
                          <Row>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Automation Display
                                </label>
                                <Input
                                  name="automations.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["automations.display"]
                                      ? privilegeValues["automations.display"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Automation Firmware Upgrade Edit
                                </label>
                                <Input
                                  name="automations.firmware.upgrade.edit"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues[
                                      "automations.firmware.upgrade.edit"
                                    ]
                                      ? privilegeValues[
                                          "automations.firmware.upgrade.edit"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Automation GAM Configuration Display
                                </label>
                                <Input
                                  name="automations.gam.configuration.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues[
                                      "automations.gam.configuration.display"
                                    ]
                                      ? privilegeValues[
                                          "automations.gam.configuration.display"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Automation GAM Configuration Edit
                                </label>
                                <Input
                                  name="automations.gam.configuration.edit"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues[
                                      "automations.gam.configuration.edit"
                                    ]
                                      ? privilegeValues[
                                          "automations.gam.configuration.edit"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Automation GAM Configuration Template Edit
                                </label>
                                <Input
                                  name="automations.gam.configuration.template.edit"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues[
                                      "automations.gam.configuration.template.edit"
                                    ]
                                      ? privilegeValues[
                                          "automations.gam.configuration.template.edit"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Endpoint Provisioning Display
                                </label>
                                <Input
                                  name="installations.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["installations.display"]
                                      ? privilegeValues["installations.display"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Installations Site List
                                </label>
                                <Input
                                  name="installations.site.list"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["installations.site.list"]
                                      ? privilegeValues[
                                          "installations.site.list"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Installations Site Edit
                                </label>
                                <Input
                                  name="installations.site.edit"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["installations.site.edit"]
                                      ? privilegeValues[
                                          "installations.site.edit"
                                        ]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col></Col>
                            <Col></Col>
                          </Row>
                        </TabPane>
                        <TabPane tabId="monitoring" role="tabpanel">
                          <Row>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Alarms Display
                                </label>
                                <Input
                                  name="alarms.display"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["alarms.display"]
                                      ? privilegeValues["alarms.display"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <FormGroup>
                                <label className={"settingLabel"}>
                                  Alarms RADIUS Test
                                </label>
                                <Input
                                  name="alarms.radius.test"
                                  type="number"
                                  onChange={handleInputPrivilegeChange}
                                  min="0"
                                  max="15"
                                  value={
                                    privilegeValues["alarms.radius.test"]
                                      ? privilegeValues["alarms.radius.test"]
                                      : ""
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col></Col>
                            <Col></Col>
                            <Col></Col>
                          </Row>
                        </TabPane>
                      </TabContent>
                    </TabPane>
                    <TabPane tabId="email" role="tabpanel">
                      <Row>
                        <Col>
                          <label className={"settingLabel"}>Enable</label>
                          <FormGroup>
                            <Switch
                              name="email_enable"
                              offColor="success"
                              offText={
                                <i className="nc-icon nc-simple-remove" />
                              }
                              onColor="success"
                              onText={<i className="nc-icon nc-check-2" />}
                              onChange={handleSwitchChange}
                              value={
                                settingValues["email_enable"] == "true"
                                  ? true
                                  : false
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col></Col>
                        <Col></Col>
                      </Row>
                      <Row>
                        <Col>
                          <FormGroup>
                            <label className={"settingLabel"}>Host Name</label>
                            <Input
                              name="email_host_name"
                              type="text"
                              onChange={handleInputChange}
                              value={
                                settingValues["email_host_name"]
                                  ? settingValues["email_host_name"]
                                  : ""
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <label className={"settingLabel"}>Host Port</label>
                            <Input
                              name="email_host_port"
                              type="number"
                              onChange={handleInputChange}
                              min="0"
                              value={
                                settingValues["email_host_port"]
                                  ? settingValues["email_host_port"]
                                  : ""
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <label className={"settingLabel"}>Host SSL</label>
                          <FormGroup>
                            <Switch
                              name="email_host_ssl"
                              offColor="success"
                              offText={
                                <i className="nc-icon nc-simple-remove" />
                              }
                              onColor="success"
                              onText={<i className="nc-icon nc-check-2" />}
                              onChange={handleSwitchChange}
                              value={
                                settingValues["email_host_ssl"] == "true"
                                  ? true
                                  : false
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <FormGroup>
                            <label className={"settingLabel"}>
                              Host Username
                            </label>
                            <Input
                              name="email_host_username"
                              type="text"
                              onChange={handleInputChange}
                              value={
                                settingValues["email_host_username"]
                                  ? settingValues["email_host_username"]
                                  : ""
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <label className={"settingLabel"}>
                              Host Password
                            </label>
                            <Input
                              name="email_host_password"
                              type="password"
                              onChange={handleInputChange}
                              value={
                                settingValues["email_host_password"]
                                  ? settingValues["email_host_password"]
                                  : ""
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <label className={"settingLabel"}>
                              Host Email From
                            </label>
                            <Input
                              name="email_host_from"
                              type="text"
                              onChange={handleInputChange}
                              value={
                                settingValues["email_host_from"]
                                  ? settingValues["email_host_from"]
                                  : ""
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </TabPane>
                  </TabContent>
                  <Button
                    className="btn-round"
                    color="info"
                    type="submit"
                    disabled={!hasChanged}
                  >
                    Save
                  </Button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default SettingEdit;
